import React from 'react';

import Button from 'components/designSystem/Button/Button';

import styles from './LocationLookupFailedModal.module.scss';

interface LocationLookupFailedModalProps {
  hideModal: () => void;
}

export default function LocationLookupFailedModal({ hideModal }: LocationLookupFailedModalProps) {
  return (
    <div className={styles.dialogModal}>
      <h2 className={styles.title}>Something went wrong</h2>
      <p className={styles.message}>We were unable to determine your location. Please try again.</p>
      <div>
        <Button onClick={hideModal} isFullWidth>
          Ok
        </Button>
      </div>
    </div>
  );
}
